export interface CalendarForSort {
  id: string;
  name: string;
  primary: boolean;
  accessRole: string;
}

export function sortGoogleCalendars<T extends CalendarForSort>(calendars: readonly T[]): T[] {
  return [...calendars].sort((a, b) => {
    if (a.primary && !b.primary) return -1;
    if (!a.primary && b.primary) return 1;
    const aWritable = a.accessRole === 'owner' || a.accessRole === 'writer';
    const bWritable = b.accessRole === 'owner' || b.accessRole === 'writer';
    if (aWritable && !bWritable) return -1;
    if (!aWritable && bWritable) return 1;
    return a.name.localeCompare(b.name);
  });
}
